import access from '@/api/access';

export default{
    install(Vue){
        Vue.config.globalProperties.$movePage = function(type, menu, param = undefined){
            if(type === 'D'){
                var name = ''
                switch(menu){
                    case '/login':
                        name = 'login'
                        break;
                    case '/':
                        name = 'home'
                        break;
                }
                if(menu === '/login'){
                    if(param !== undefined){
                        this.$router.push({name: name, query: param})
                        return
                    }
                }
                this.$router.push({name: name})
            }else if(type=== 'S'){
                if(menu.menupath === 'nurseCall'){
                    access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menupath)
                    return 'CallNurse'

                }else if(menu.menugrup === 'LN'){
                    access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menucode)
                    window.open(`${menu.menupath}`);
                }
                else{
                    access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menupath)
                    this.$router.push({name:menu.menupath, params:{headTitle:menu.menuname}})
                }
            }else if(type === 'A'){
                access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menupath)
                switch(menu.menupath){
                    case 'searchingAppointment':
                        this.$router.push({name:'searchinAppointmentArg', params:{headTitle:'의료진 검색', searchingData: menu.argument}})
                        break;
                }
            }else if(type === 'C'){
                access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menupath)
                this.$router.push({name:menu.menupath, params:{subTitle:menu.menuname}, state:{code: menu.menucode}})
            }else if(type === 'C1'){
                access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno,menu.menupath)
                this.$router.replace({name:menu.menupath, params:{subTitle:menu.menuname}, state:{code: menu.menucode}})
            }else if(type === 'M'){
                access.accessMenu(this.$store.state.provider.id,this.$store.state.userInfo.idno, menu)
                switch(menu){
                    case 'resetPassword':
                        this.$router.push({name:'resetPassword', params:{headTitle:'비밀번호 변경'}})
                        break;
                    case 'hospitalTel':
                        this.$router.push({name:'hospitalTel', params:{headTitle:'주요전화번호 안내'}})
                        break;
                    case 'movingRoute':
                        this.$router.push({name:'movingRoute', params:{headTitle:'가야할 곳'}})
                        break;
                    case 'userInfoPage':
                        this.$router.push({name:'userInfoPage', params:{headTitle:'회원정보수정'}})
                        break; 
                    case 'openInfoReservation':
                        this.$router.push({name:'openInfoReservation', params:{headTitle:'예약 조회'}})
                        break;   
                    case 'register':
                        this.$router.push({name:'register', params:{headTitle:'회원가입'}})
                        break;
                    case 'signOut':
                        this.$router.push({name:'signOut', params:{headTitle:'회원탈퇴'}})
                        break;
                    case 'parking':
                        this.$router.push({name:'parking', params:{headTitle:'주차안내'}})
                        break;  
                    case 'findRegisterNum':
                        this.$router.push({name:'findRegisterNum', params:{headTitle:'등록번호/비밀번호 찾기'}})
                        break;
                    case 'findPassword':
                        this.$router.push({name:'findPassword', params:{headTitle:'등록번호/비밀번호 찾기'}})
                        break; 
                    case 'cardRegister':
                        this.$router.push({name:'cardRegister', params:{headTitle:'카드관리'}})
                        break;
                    case 'cardPayment':
                        this.$router.push({name:'cardPayment', params:{headTitle:'결제정보', patientData: param}})
                        break; 
                    case 'certificateNewA':
                        this.$router.push({name:'certificateNew', params:{headTitle:'제증명 신청', kindData: 'A'}})
                        break; 
                    case 'certificateNewB':
                        this.$router.push({name:'certificateNew', params:{headTitle:'의무기록 사본 발급', kindData: 'B'}})
                        break;
                    case 'emailAuthentication':
                        this.$router.push({name:'emailAuthentication', params:{headTitle:'이메일 인증'}})
                        break; 
                    case 'phoneChange':
                        this.$router.push({name:'phoneChange', params:{headTitle:'휴대폰 번호 변경'}})
                        break;
                    case 'nonMember':
                        this.$router.push({name:'nonMember', params:{headTitle:'간편예약'}})
                        break;
                    case 'nonCheck':
                        this.$router.push({name:'nonCheck', params:{headTitle:'간편예약내역'}})
                        break;
                    case 'appointmentInquiry':
                        this.$router.push({name:'appointmentInquiry', params:{headTitle:'비회원예약조회', patientData: param}})
                        break;
                    case 'medicalCheckHistory':
                        this.$router.push({name:'medicalCheckHistory', params:{headTitle:'검진예약내역', patientData: param}})
                        break; 
                    case 'openReservation':
                        this.$router.push({name:'openReservation', params:{headTitle:'진료예약'}})
                        break; 
                    case 'documentApplicationWait':
                        this.$router.push({name:'documentApplicationWait'})
                        break;
                    case 'changeAppointment':
                        this.$router.push({name:'changeAppointment', params:{headTitle:'예약변경', patientData: param}})
                        break; 
                    case 'openPrescriptionList':
                        this.$router.push({name:'openPrescriptionList', params:{headTitle:'처방전보기'}})
                        break;
                }
            }
            return ''
        }        
    }
}